
import { computed, defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { useDebouncedRef } from '@/lib/hooks/useDebouncedRef';
import { useAccountStore } from '@/store/useAccount';
import { table } from '@/store/stateless/tables';

export default defineComponent({
  setup() {
    const account = useAccountStore();
    const { data, loading, page, pageSize, searchQuery, totalPages } = storeToRefs(account);

    const pageModel = computed({
      get: () => page.value + 1,
      set: (v: number) => { page.value = v - 1; },
    });

    useDebouncedRef(() => (page.value = 0), [searchQuery]);
    useDebouncedRef(() => window.scrollTo(0, 0), [page, pageSize, searchQuery]);

    return {
      data,
      pageModel,
      searchQuery,
      totalPages,
      loading,
      table,
    };
  },
});
